// src/components/orders/wizard/SuccessStep.js
import React from 'react';
import { CheckCircle, Download, RefreshCw, Clock, Wifi, WifiOff, Plus } from 'lucide-react';

const SuccessStep = ({ 
  onReset, 
  isOnline, 
  offlineOrderId, 
  pendingSyncCount, 
  onSyncOrders 
}) => {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-6">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center">
        {/* Icona successo */}
        <div className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6" style={{backgroundColor: '#fcfbd6'}}>
          <CheckCircle className="w-12 h-12" style={{color: '#c48f75'}} />
        </div>

        {/* Titolo principale */}
        <h1 className="text-2xl font-bold text-gray-900 mb-4">
          {isOnline ? 'Ordine Creato!' : 'Ordine Salvato Offline!'}
        </h1>

        {/* Messaggio basato su stato online/offline */}
        {isOnline ? (
          <div className="space-y-4 mb-8">
            <p className="text-gray-600">
              Il tuo ordine è stato creato e inviato con successo.
            </p>
            <div className="flex items-center justify-center space-x-2 text-gray-700">
              <Wifi className="w-4 h-4" />
              <span className="text-sm font-medium">Sincronizzato online</span>
            </div>
          </div>
        ) : (
          <div className="space-y-4 mb-8">
            <p className="text-gray-600">
              Il tuo ordine è stato salvato e verrà sincronizzato automaticamente quando torni online.
            </p>
            <div className="bg-orange-50 border border-orange-200 rounded-lg p-4">
              <div className="flex items-center space-x-2 text-orange-700 mb-2">
                <WifiOff className="w-4 h-4" />
                <span className="text-sm font-medium">Modalità Offline</span>
              </div>
              {offlineOrderId && (
                <p className="text-xs text-orange-600">
                  ID Offline: {offlineOrderId}
                </p>
              )}
            </div>
          </div>
        )}

        {/* Info ordini pendenti */}
        {isOnline && pendingSyncCount > 0 && (
          <div className="border rounded-lg p-4 mb-6" style={{backgroundColor: '#fcfbd6', borderColor: '#c48f75'}}>
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-2">
                <Clock className="w-4 h-4 text-gray-700" />
                <span className="text-sm font-medium text-gray-900">
                  {pendingSyncCount} ordini da sincronizzare
                </span>
              </div>
              <button
                onClick={onSyncOrders}
                className="flex items-center space-x-1 px-3 py-1 text-white text-xs rounded-lg transition-colors"
                style={{backgroundColor: '#c48f75'}}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#4c4849'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#c48f75'}
              >
                <RefreshCw className="w-3 h-3" />
                <span>Sincronizza</span>
              </button>
            </div>
          </div>
        )}

        {/* Azioni disponibili */}
        <div className="space-y-3">
          {/* Pulsante principale - Nuovo ordine */}
          <button
            onClick={onReset}
            className="w-full flex items-center justify-center space-x-2 px-6 py-3 text-white rounded-lg transition-colors font-medium"
            style={{backgroundColor: '#c48f75'}}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#4c4849'}
            onMouseLeave={(e) => e.target.style.backgroundColor = '#c48f75'}
          >
            <Plus className="w-5 h-5" />
            <span>Crea Nuovo Ordine</span>
          </button>

          {/* Pulsanti secondari */}
          <div className="grid grid-cols-2 gap-3">
            <button
              onClick={() => window.history.back()}
              className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-sm"
            >
              Indietro
            </button>
            
            <button
              onClick={() => window.location.href = '/orders'}
              className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-sm"
            >
              Vedi Ordini
            </button>
          </div>
        </div>

        {/* Footer con info aggiuntive */}
        <div className="mt-8 pt-6 border-t border-gray-200">
          <div className="flex items-center justify-center space-x-4 text-xs text-gray-500">
            {isOnline ? (
              <>
                <div className="flex items-center space-x-1">
                  <div className="w-2 h-2 rounded-full" style={{backgroundColor: '#c48f75'}}></div>
                  <span>Online</span>
                </div>
                <span>•</span>
                <span>Sincronizzazione automatica attiva</span>
              </>
            ) : (
              <>
                <div className="flex items-center space-x-1">
                  <div className="w-2 h-2 bg-orange-500 rounded-full animate-pulse"></div>
                  <span>Offline</span>
                </div>
                <span>•</span>
                <span>Dati salvati localmente</span>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessStep;